<template>
  <article>
    <div
      @mouseenter="$store.state.utils.hoverOnNotifications = false"
      @mouseleave="$store.state.utils.hoverOnNotifications = true"
      v-for="(message, index) in $store.state.utils.notificationBox"
      :key="index"
      class="toast-container position-fixed bottom-0 end-0 p-3"
    >
      <div class="shadow p-3 mb-1 bg-body rounded" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="toast-header">
          <i class="fa-solid fa-circle-info me-2 text-info" v-if="message.type == 'info'"></i>
          <i class="fa-solid fa-triangle-exclamation me-2 text-warning" v-if="message.type == 'warning'"></i>
          <i class="fa-solid fa-lightbulb me-2 text-primary" v-if="message.type == 'hint'"></i>
          <i class="fa-solid fa-circle-check me-2 text-success" v-if="message.type == 'success'"></i>
          <strong class="me-auto" v-if="message.title">{{ message.title }}</strong>
        </div>
        <div class="toast-body">
          {{ message.message }}
          <a v-if="message.url" :href="message.url"> link</a>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: "Notifications",
  data() {
    return {};
  },

  mounted() {
    this.$nextTick(() => {});
  },

  methods: {
    canselPopup(index) {
      this.$store.state.utils.notificationBox.splice(index, 1);
    },
  },
};
</script>
